import axios from "axios";
import { tableDetails } from "../constants_map.js";
import getAPIMap from "../api_map.js";
import getIP from "../getIP.js";
const IP = getIP();
import { parseCampaignIds } from "utils/QueryStringHelper.js";
import { category as categoryCodeMap } from "../components/dashboard/dashboard.constants";

import {
  customDateStartUTCTimeZoneZDetails,
  customDateEndUTCTimeZoneZDetails,
  getTimeZoneInHours,
  customDateStartUTCTimeZoneZ,
  customDateEndUTCTimeZoneZ,
  getLocalFormattedDate,
} from "../utils/DateOrdinals.js";

const waInterfaceMapping = {
  WEB: 0,
  API: 1,
};

const getReports = async ({ pageParam = 1, queryKey }) => {
  const isView = queryKey[0].includes("View");
  const channel = queryKey[2].channel;
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const pgSize = tableDetails.pageSize || "10";
  const format = queryKey[3] || "csv";
  const type = queryKey[4] || "";
  const sender = queryKey[2].sender
    ? queryKey[2].sender?.toLowerCase() === "all"
      ? ""
      : queryKey[2].sender
    : "";
  const status = queryKey[2].status
    ? queryKey[2].status?.toLowerCase() === "all"
      ? ""
      : queryKey[2].status
    : "";
  const country = queryKey[2].country
    ? queryKey[2].country?.toLowerCase() === "all"
      ? ""
      : queryKey[2].country
    : "";

  const organizationId = queryKey[2].organizationId;
  let userId = queryKey[2].user;
  const userLower = queryKey[2].user?.toLowerCase();

  if (organizationId) userId = organizationId;
  else if (userLower === "all" || userLower === "self") userId = "";
  else if (queryKey[2].user) userId = queryKey[2].user;
  else userId = "";

  const iType = queryKey[2].interface
    ? queryKey[2].interface?.toLowerCase() === "all"
      ? ""
      : queryKey[2].interface
    : "";
  const direction = queryKey[2].direction
    ? queryKey[2].direction?.toLowerCase() === "all"
      ? ""
      : queryKey[2].direction
    : "";
  // Backend expects a numeric m_ctg code, not the text label. Map the dropdown
  // value (Promotional/Transactional/OTP) to its code via categoryCodeMap.
  // "All" (or unset) => no filter.
  const category =
    queryKey[2].category && queryKey[2].category?.toLowerCase() !== "all"
      ? categoryCodeMap[queryKey[2].category]
      : "";
  const provider = queryKey[2].provider
    ? queryKey[2].provider?.toLowerCase() === "all"
      ? ""
      : queryKey[2].provider
    : "";
  const bind = queryKey[2].bind
    ? queryKey[2].bind?.toLowerCase() === "all"
      ? ""
      : queryKey[2].bind
    : "";
  const campaignId = parseCampaignIds(
    queryKey[2].campNames,
    queryKey[2].campaignId
  );
  const loggedInRole = queryKey[5] || "PA";

  const msisdnString = msisdn ? `&aud=${msisdn}` : "";
  const senderString = sender ? `&s_adr=${encodeURIComponent(sender)}` : "";
  const countryString = country ? `&country=${country}` : "";
  const statusString = status ? `&s_st=${status}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  // Guard on !== "" so the numeric code 0 (Promotional) is not dropped as falsy.
  const categoryString =
    category !== "" && category !== undefined && category !== null
      ? `&m_ctg=${category}`
      : "";
  const userIdString = userId
    ? loggedInRole === "PA"
      ? `&o_id=${userId}`
      : `&u_id=${userId}`
    : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";
  const pgIndexString = isView
    ? `&pgSize=${pgSize}&pgIndex=${
        type === "MT_DETAIL" ? pageParam - 1 : pageParam
      }`
    : `&download=true&format=${format}${
        queryKey[2]?.rptName
          ? `&rptName=${encodeURIComponent(queryKey[2].rptName)}`
          : ""
      }`;
  const cmpnIdString = campaignId ? `&p_id=${campaignId}` : "";

  const { userEmail } = queryKey[2] || {}; // values object.
  const userEmailString = userEmail ? `&userEmail=${userEmail}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
    ...(queryKey[0] === "MtSummaryDownload" && { responseType: "arraybuffer" }),
  };

  let url = `${IP}${getAPIMap(
    type === "MT_DETAIL" ? "getDetailedReport" : "getSummaryReport"
  )}?fDate=${fDate}&tDate=${tDate}${msisdnString}${senderString}${iTypeString}${userIdString}${directionString}${categoryString}${statusString}${providerString}${bindString}${countryString}${pgIndexString}${cmpnIdString}${userEmailString}`;

  url = url
    .replace("{ch}", channel?.toLowerCase() || "sms")
    .replace("{type}", "mt");

  let rsp = await axios.post(url, {}, config);

  if (queryKey[0] === "MtSummaryView") {
    rsp.data?.data?.sort(
      (a, b) => parseInt(b.timestamp) - parseInt(a.timestamp)
    );
  } else if (queryKey[0] === "MtDetailView") {
    rsp.data?.data?.sort(
      (a, b) => parseInt(b["Accepted Time"]) - parseInt(a["Accepted Time"])
    );
  }

  let resp = isView
    ? { response: rsp, nextPage: pageParam + 1 }
    : { response: rsp };
  return resp;
};
const getVoiceReports = async ({ pageParam = 0, queryKey }) => {
  const loggedInRole = queryKey[5] || "PA";
  const isView = queryKey[0].includes("Download");
  const channel = queryKey[2].channel;
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const displayStatus = queryKey[2].displayStatus || "";
  const finalStatus =
    queryKey[2].finalStatus?.toLowerCase() === "all"
      ? ""
      : queryKey[2].finalStatus;

  const rateSheetName = queryKey[2].rateSheetName || "";
  const campaignCategory = queryKey[2].campaignCategory || "";

  const organizationId = queryKey[2].organizationId;
  let userId = queryKey[2].user;
  const userLower = queryKey[2].user?.toLowerCase();

  if (organizationId) userId = organizationId;
  else if (userLower === "all" || userLower === "self") userId = "";
  else if (queryKey[2].user) userId = queryKey[2].user;
  else userId = "";

  const iType = queryKey[2].interface
    ? queryKey[2].interface?.toLowerCase() === "all"
      ? ""
      : queryKey[2].interface
    : "";

  const direction = queryKey[2].direction
    ? queryKey[2].direction === "incoming"
      ? "IBD"
      : queryKey[2].direction === "outgoing"
      ? "OBD"
      : ""
    : "";
  const pgSize = tableDetails.pageSize || "10";
  const format = queryKey[3] || "csv";
  const type = queryKey[4] || "";
  const productType = queryKey[2].productType || "";
  const packageName = queryKey[2].packageName || "";
  const enterpriseUserNo = queryKey[2].enterpriseUserNo || "";
  const enterpriseNo = queryKey[2].enterpriseNo || "";
  const customerNo = queryKey[2].customerNo || "";
  const callerId = queryKey[2].callerId || "";
  const audioSource = queryKey[2].audioSource || "";
  const campaignName = queryKey[2].campaignName || "";
  const provider = queryKey[2].provider
    ? queryKey[2].provider?.toLowerCase() === "all"
      ? ""
      : queryKey[2].provider
    : "";
  const bind = queryKey[2].bind
    ? queryKey[2].bind?.toLowerCase() === "all"
      ? ""
      : queryKey[2].bind
    : "";
  const campaignId = parseCampaignIds(
    queryKey[2].campNames,
    queryKey[2].campaignId
  );

  const msisdnString = msisdn ? `&aud=${msisdn}` : "";
  const displayStatusString = displayStatus ? `&s_st=${displayStatus}` : "";
  const finalStatusString = finalStatus ? `&f_st=${finalStatus}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  const userIdString = userId
    ? loggedInRole === "PA"
      ? `&o_id=${userId}`
      : `&u_id=${userId}`
    : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const productTypeString = productType ? `&pr_tp=${productType}` : "";
  const rateSheetNameSting = rateSheetName
    ? `&rateSheetName=${rateSheetName}`
    : "";
  const packageNameString = packageName ? `&pkg_nm=${packageName}` : "";
  const enterpriseUserNumberString = enterpriseUserNo
    ? `&ent_u_num=${enterpriseUserNo}`
    : "";
  const campaignCategoryNameString = campaignCategory
    ? `&m_ctg=${campaignCategory}`
    : "";
  const enterpriseNumberString = enterpriseNo ? `&ent_num=${enterpriseNo}` : "";
  const customerNumberString = customerNo ? `&cus_num=${customerNo}` : "";
  const callerIdString = callerId ? `&c_id_num=${callerId}` : "";
  const audioSourceString = audioSource ? `&aud_src=${audioSource}` : "";
  const campaignNameString = campaignName
    ? `&campaignName=${campaignName}`
    : "";
  const pgIndexString = !isView
    ? `&pgSize=${pgSize}&pgIndex=${pageParam}`
    : `&download=true&format=${format}${
        queryKey[2]?.rptName
          ? `&rptName=${encodeURIComponent(queryKey[2].rptName)}`
          : ""
      }`;
  const bindString = bind ? `&bind=${bind}` : "";
  const cmpnIdString = campaignId ? `&p_id=${campaignId}` : "";
  const { userEmail } = queryKey[2] || {}; // values object.
  const userEmailString = userEmail ? `&userEmail=${userEmail}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = `${IP}${getAPIMap(
    type === "detailed" ? "getDetailedReport" : "getSummaryReport"
  )}?fDate=${fDate}&tDate=${tDate}${msisdnString}${iTypeString}${userIdString}${directionString}${displayStatusString}${finalStatusString}${providerString}${pgIndexString}${productTypeString}${rateSheetNameSting}${audioSourceString}${campaignNameString}${customerNumberString}${callerIdString}${enterpriseNumberString}${enterpriseUserNumberString}${packageNameString}${campaignCategoryNameString}${bindString}${cmpnIdString}${userEmailString}`;

  if (!direction && type === "detailed") {
    url = url.replace(
      "{type}",
      productType === "vr" ? "IBD_DETAIL" : "OBD_DETAIL"
    );
  } else {
    if (type === "summary") {
      url = url.replace("{type}", direction + `VOICE_SUMMARY`);
    } else {
      url = url.replace("{type}", direction + `_DETAIL`);
    }
  }
  url = url.replace("{ch}", channel?.toLowerCase() || "voice");

  let rsp = await axios.post(url, {}, config);
  let resp = isView
    ? { response: rsp }
    : { response: rsp, nextPage: pageParam + 1 };

  return resp;
};

const getEMAILReports = async ({ pageParam = 1, queryKey }) => {
  const isView = queryKey[0].includes("View");
  const channel = queryKey[2].channel;
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const pgSize = tableDetails.pageSize || "10";
  const format = queryKey[3] || "csv";
  const type = queryKey[4] || "";
  const sender = queryKey[2].sender
    ? queryKey[2].sender?.toLowerCase() === "all"
      ? ""
      : queryKey[2].sender
    : "";
  const status = queryKey[2].status
    ? queryKey[2].status?.toLowerCase() === "all"
      ? ""
      : queryKey[2].status
    : "";
  const emailId = queryKey[2].emailid
    ? queryKey[2].emailid?.toLowerCase() === "all"
      ? ""
      : queryKey[2].emailid
    : "";

  const organizationId = queryKey[2].organizationId;
  let userId = queryKey[2].user;
  const userLower = queryKey[2].user?.toLowerCase();

  if (organizationId) userId = organizationId;
  else if (userLower === "all" || userLower === "self") userId = "";
  else if (queryKey[2].user) userId = queryKey[2].user;
  else userId = "";

  const iType = queryKey[2].interface
    ? queryKey[2].interface?.toLowerCase() === "all"
      ? ""
      : queryKey[2].interface
    : "";
  const direction = queryKey[2].direction
    ? queryKey[2].direction?.toLowerCase() === "all"
      ? ""
      : queryKey[2].direction
    : "";
  // Backend expects a numeric m_ctg code, not the text label. Map the dropdown
  // value (Promotional/Transactional/Authentication) to its code via
  // categoryCodeMap. "All" (or unset) => no filter.
  const category =
    queryKey[2].category && queryKey[2].category?.toLowerCase() !== "all"
      ? categoryCodeMap[queryKey[2].category]
      : "";
  const provider = queryKey[2].provider
    ? queryKey[2].provider?.toLowerCase() === "all"
      ? ""
      : queryKey[2].provider
    : "";
  const bind = queryKey[2].bind
    ? queryKey[2].bind?.toLowerCase() === "all"
      ? ""
      : queryKey[2].bind
    : "";
  const campaignId = parseCampaignIds(
    queryKey[2].campNames,
    queryKey[2].campaignId
  );

  //u_id and a_id
  const loggedRole = queryKey[5];
  const msisdnString = msisdn ? `&to=${msisdn}` : "";
  const emailsenderString = sender ? `&s_adr=${sender}` : "";
  const emailRecString = emailId ? `&recipient=${emailId}` : "";
  const statusString = status ? `&s_st=${status}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  // Guard on !== "" so the numeric code 0 (Promotional) is not dropped as falsy.
  const categoryString =
    category !== "" && category !== undefined && category !== null
      ? `&m_ctg=${category}`
      : "";
  const userIdString = userId
    ? loggedRole
      ? loggedRole === "PA"
        ? `&o_id=${userId}`
        : `&u_id=${userId}`
      : ""
    : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";
  const pgIndexString = isView
    ? `&pgSize=${pgSize}&pgIndex=${pageParam - 1}`
    : `&download=true&format=${format}${
        queryKey[2]?.rptName
          ? `&rptName=${encodeURIComponent(queryKey[2].rptName)}`
          : ""
      }`;
  const cmpnIdString = campaignId ? `&p_id=${campaignId}` : "";

  const { userEmail } = queryKey[2] || {}; // values object.
  const userEmailString = userEmail ? `&userEmail=${userEmail}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = `${IP}${getAPIMap(
    type === "ALL_DETAIL_EMAIL"
      ? "getWADetailedReport"
      : "getEMAILSummaryReport"
  )}?fDate=${fDate}&tDate=${tDate}${msisdnString}${emailsenderString}${iTypeString}${userIdString}${directionString}${categoryString}${statusString}${providerString}${bindString}${emailRecString}${pgIndexString}${cmpnIdString}${userEmailString}`;

  url = url.replace("{ch}", channel?.toLowerCase() || "email");

  let rsp = await axios.post(url, {}, config);
  let resp = isView
    ? { response: rsp, nextPage: pageParam + 1 }
    : { response: rsp };
  return resp;
};
const getWAReports = async ({ pageParam = 1, queryKey }) => {
  const loggedRole = queryKey[5];
  const isView = queryKey[0].includes("View");
  const channel = queryKey[2].channel;
  const fDate = customDateStartUTCTimeZoneZDetails(queryKey[2].startDate) || "";
  const tDate = customDateEndUTCTimeZoneZDetails(queryKey[2].endDate) || "";
  const msisdn = queryKey[2].msisdn;
  const pgSize = tableDetails.pageSize || "10";
  const format = queryKey[3] || "csv";
  const type = queryKey[4] || "";
  const temp_id = queryKey[2].temp_id || "";
  let timeZone = getTimeZoneInHours();

  const whatsAppnumber = queryKey[2].whatsAppnumber
    ? queryKey[2].whatsAppnumber?.toLowerCase() === "all"
      ? ""
      : queryKey[2].whatsAppnumber
    : "";
  const status = queryKey[2].status
    ? queryKey[2].status?.toLowerCase() === "all"
      ? ""
      : queryKey[2].status
    : "";
  const country = queryKey[2].country
    ? queryKey[2].country?.toLowerCase() === "all"
      ? ""
      : queryKey[2].country
    : "";

  const organizationId = queryKey[2].organizationId;
  let userId = queryKey[2].user;
  const userLower = queryKey[2].user?.toLowerCase();

  if (organizationId) userId = organizationId;
  else if (userLower === "all") userId = "";
  else if (userLower === "self" && loggedRole === "EA")
    userId = queryKey[1]?.sub;
  else if (userLower === "self") userId = "";
  else if (queryKey[2].user) userId = queryKey[2].user;
  else userId = "";

  const iType = queryKey[2].interface
    ? queryKey[2].interface?.toLowerCase() === "all"
      ? ""
      : queryKey[2].interface
    : "";
  const direction = queryKey[2].direction
    ? queryKey[2].direction?.toLowerCase() === "all"
      ? ""
      : queryKey[2].direction
    : "";
  const provider = queryKey[2].provider
    ? queryKey[2].provider?.toLowerCase() === "all"
      ? ""
      : queryKey[2].provider
    : "";
  const bind = queryKey[2].bind
    ? queryKey[2].bind?.toLowerCase() === "all"
      ? ""
      : queryKey[2].bind
    : "";
  const campaignId = parseCampaignIds(
    queryKey[2].campNames,
    queryKey[2].campaignId
  );

  //u_id and a_id
  const msisdnString = msisdn ? `&to=${msisdn}` : "";
  let senderString = "";
  const countryString = country ? `&country=${country}` : "";
  // const statusString = status ? `&s_st=${status}` : "";
  const statusString = status ? `&status=${status}` : "";
  const iTypeString = iType ? `&i_tp=${waInterfaceMapping[iType]}` : "";
  const directionString = direction ? `&m_ctg=${direction}` : "";

  const tempIdString = temp_id ? `&temp_id=${temp_id}` : "";

  const userIdString = userId
    ? loggedRole
      ? loggedRole === "PA"
        ? `&o_id=${userId}`
        : `&u_id=${userId}`
      : ""
    : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";
  const pgIndexString = isView
    ? `&pgSize=${pgSize}&pgIndex=${pageParam - 1}`
    : `&download=true&format=${format}${
        queryKey[2]?.rptName
          ? `&rptName=${encodeURIComponent(queryKey[2].rptName)}`
          : ""
      }`;

  const timeZoneString =
    type === "ALL_DETAIL_WA" ? "" : `&timeZone=${timeZone}`;
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]?.token}`,
    },
  };

  if (type === "ALL_DETAIL_WA" && whatsAppnumber) {
    // (type === "ALL_DETAIL_WA") ? "" : whatsAppnumber ? `&wa_ba=${whatsAppnumber}` : "";
    senderString = `&from=${whatsAppnumber}`;
  } else if (whatsAppnumber) {
    senderString = `&wa_ba=${whatsAppnumber}`;
  }

  const cmpnIdString = campaignId ? `&p_id=${campaignId}` : "";
  const { userEmail } = queryKey[2] || {}; // values object.
  const userEmailString = userEmail ? `&userEmail=${userEmail}` : "";

  let url = `${IP}${getAPIMap(
    type === "ALL_DETAIL_WA" ? "getWADetailedReport" : "getWASummaryReport"
  )}?fDate=${fDate}&tDate=${tDate}${msisdnString}${senderString}${iTypeString}${userIdString}${directionString}${statusString}${providerString}${bindString}${countryString}${pgIndexString}${timeZoneString}${cmpnIdString}${tempIdString}${userEmailString}`;

  url = url.replace("{ch}", channel?.toLowerCase() || "wa");

  let rsp = await axios.post(url, {}, config);
  let resp = isView
    ? { response: rsp, nextPage: pageParam + 1 }
    : { response: rsp };
  return resp;
};

const getUsersForReports = async (
  search,
  prevOptions,
  pgIndex,
  token,
  channel,
  userName
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  var url =
    IP +
    getAPIMap("getuser") +
    `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
      search !== "" ? `&search=${search}` : ""
    }`;

  let response = await axios.get(url, config);

  let userOptions = [];
  response?.data?.data?.forEach((e) => {
    userOptions.push({
      value: e.id,
      label: e.name,
    });
  });

  if (pgIndex === 1)
    userOptions = [
      ...[
        { label: "All", value: "all" },
        { label: userName || "Self", value: "self" },
      ],
      ...userOptions,
    ];

  return {
    options: userOptions.length > 0 ? userOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getUsersForReportsEmail = async (
  search,
  prevOptions,
  pgIndex,
  token,
  channel,
  userName
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  var url =
    IP +
    getAPIMap("getuser") +
    `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
      search !== "" ? `&search=${search}` : ""
    }`;

  let response = await axios.get(url, config);

  let userOptions = [];
  response?.data?.data?.forEach((e) => {
    userOptions.push({
      value: e.id,
      label: e.name,
    });
  });

  if (pgIndex === 1)
    userOptions = [...[{ label: "All", value: "all" }], ...userOptions];

  return {
    options: userOptions.length > 0 ? userOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getEnterprisesForReports = async (
  search,
  prevOptions,
  pgIndex,
  token,
  channel,
  userName
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  var url =
    IP +
    getAPIMap("enterprisePaginationApi") +
    `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
      search !== "" ? `&search=${search}` : ""
    }`;
  let response = await axios.get(url, config);

  let enterpriseOptions = [];
  response?.data?.data?.forEach((e) => {
    enterpriseOptions.push({
      value: e.profile.id,
      label: e.profile.name,
      ownerId: e.profile.ownerId,
    });
  });

  if (pgIndex === 1)
    enterpriseOptions = [
      ...[
        { label: "All", value: "all" },
        { label: userName || "Self", value: "self" },
      ],
      ...enterpriseOptions,
    ];

  return {
    options: enterpriseOptions.length > 0 ? enterpriseOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getProvidersForReport = async (
  search,
  prevOptions,
  pgIndex,
  token,
  channel
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let url =
    IP +
    `${getAPIMap("getServices")}` +
    `?ch=${channel && channel !== "" ? channel.toLowerCase() : "sms"}${
      search !== "" ? "&search=" + search : ""
    }&pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}`;
  const response = await axios.get(url, config);
  let providerOptions = [];
  response?.data?.data?.rows?.forEach((e) => {
    providerOptions.push({
      value: e.sp_id,
      label: e.name,
    });
  });

  if (pgIndex === 1)
    providerOptions = [...[{ label: "All", value: "all" }], ...providerOptions];

  return {
    options: providerOptions.length > 0 ? providerOptions : [],
    providers: response?.data?.data?.rows,
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getProviderForBind = async (token, id, channel, from) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  var url =
    IP +
    getAPIMap("getServices") +
    `?providerId=${id}&ch=${
      channel && channel !== "" ? channel.toLowerCase() : "sms"
    }`;

  let response = await axios.get(url, config);
  response = response?.data?.data?.rows[0];
  let bindKey = channel === "sms" ? "smsc_" : "sp_sip_";
  let bindsArr = response[`${bindKey}instances`];

  let bindIdPart =
    channel === "sms" ? "smsc_" : channel === "voice" ? "sip_" : "";
  let bindNamePart =
    channel === "sms" ? "" : channel === "voice" ? "service_" : "";

  let bindsOptions = bindsArr?.map((e) => {
    return {
      value: e[`${bindIdPart}id`],
      label: e[`${bindNamePart}name`],
      disabled: from && from !== "Reports" ? e.status === 0 : false,
    };
  });

  if (
    bindsOptions.length > 0 &&
    !bindsOptions.filter((e) => e.value === "All").length &&
    channel !== "voice"
  )
    bindsOptions = [...[{ label: "All", value: "all" }], ...bindsOptions];

  return bindsOptions;
};

const getOfflineReports = async ({ queryKey }) => {
  const channel = queryKey[2].channel || "sms";
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const sender = queryKey[2].sender;
  const status = queryKey[2].status || "";
  const country = queryKey[2].country || "";
  let userId = queryKey[2].user || "";
  userId = userId === "all" ? "" : userId;
  const iType = queryKey[2].interface || "";
  const direction = queryKey[2].direction || "";
  const provider = queryKey[2].provider || "";
  const bind = queryKey[2].bind || "";
  const type = queryKey[3] || "";

  const msisdnString = msisdn ? `&aud=${msisdn}` : "";
  const senderString = sender ? `&s_adr=${sender}` : "";
  const countryString = country ? `&country=${country}` : "";
  const statusString = status ? `&s_st=${status}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  const userIdString = userId ? `&u_id=${userId}` : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = `${IP}${getAPIMap(
    "getOfflineReport"
  )}?rpt_type=${type}&start_date=${fDate.split("T")[0]}&end_date=${
    tDate.split("T")[0]
  }${msisdnString}${senderString}${iTypeString}${userIdString}${directionString}${statusString}${providerString}${bindString}${countryString}`;

  url = url.replace("{ch}", channel).replace("{type}", "download");

  let response = await axios.get(url, config);
  return response;
};

const getEmailOfflineReports = async ({ queryKey }) => {
  const channel = queryKey[2].channel || "email";
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const sender = queryKey[2].sender;
  const status = queryKey[2].status || "";
  const country = queryKey[2].country || "";
  let userId = queryKey[2].user || "";
  userId = userId === "all" ? "" : userId;
  const iType = queryKey[2].interface || "";
  const direction = queryKey[2].direction || "";
  const provider = queryKey[2].provider || "";
  const bind = queryKey[2].bind || "";
  const type = queryKey[3] || "";

  const msisdnString = msisdn ? `&recipient=${msisdn}` : "";
  const senderString = sender ? `&s_adr=${sender}` : "";
  const countryString = country ? `&country=${country}` : "";
  const statusString = status ? `&s_st=${status}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  const userIdString = userId ? `&u_id=${userId}` : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = `${IP}${getAPIMap(
    "getOfflineReport"
  )}?rpt_type=${type}&start_date=${fDate.split("T")[0]}&end_date=${
    tDate.split("T")[0]
  }${msisdnString}${senderString}${iTypeString}${userIdString}${directionString}${statusString}${providerString}${bindString}${countryString}`;

  url = url.replace("{ch}", channel).replace("{type}", "download");

  let response = await axios.get(url, config);
  return response;
};

const getOfflineVoiceReports = async ({ queryKey }) => {
  const channel = queryKey[2].channel;
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;
  const displayStatus = queryKey[2].displayStatus || "";
  const finalStatus = queryKey[2].finalStatus || "";
  const rateSheetName = queryKey[2].rateSheetName || "";
  let userId = queryKey[2].user || "";
  userId = userId === "all" ? "" : userId;
  const iType = queryKey[2].interface || "";
  const direction = queryKey[2].direction || "";
  const provider = queryKey[2].provider || "";
  //const pgSize = tableDetails.pageSize || "10";
  //const format = queryKey[3] || "csv";
  //const type = queryKey[4] || "";
  const type = queryKey[3] || "";
  const productType = queryKey[2].productType || "";
  const packageName = queryKey[2].packageName || "";
  const enterpriseUserNo = queryKey[2].enterpriseUserNo || "";
  const enterpriseNo = queryKey[2].enterpriseNo || "";
  const customerNo = queryKey[2].customerNo || "";
  const callerId = queryKey[2].callerId || "";
  const audioSource = queryKey[2].audioSource || "";
  const campaignName = queryKey[2].campaignName || "";

  const msisdnString = msisdn ? `&aud=${msisdn}` : "";
  const displayStatusString = displayStatus ? `&s_st=${displayStatus}` : "";
  const finalStatusString = finalStatus ? `&f_st=${finalStatus}` : "";
  const iTypeString = iType ? `&i_tp=${iType}` : "";
  const directionString = direction ? `&direction=${direction}` : "";
  const userIdString = userId ? `&u_id=${userId}` : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const productTypeString = productType ? `&pr_tp=${productType}` : "";
  const rateSheetNameSting = rateSheetName
    ? `&rateSheetName=${rateSheetName}`
    : "";
  const packageNameString = packageName ? `&pkg_nm=${packageName}` : "";
  const enterpriseUserNumberString = enterpriseUserNo
    ? `&ent_u_num=${enterpriseUserNo}`
    : "";
  const enterpriseNumberString = enterpriseNo ? `&ent_num=${enterpriseNo}` : "";
  const customerNumberString = customerNo ? `&cus_num=${customerNo}` : "";
  const callerIdString = callerId ? `&c_id_num=${callerId}` : "";
  const audioSourceString = audioSource ? `&aud_src=${audioSource}` : "";
  const campaignNameString = campaignName
    ? `&campaignName=${campaignName}`
    : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = `${IP}${getAPIMap(
    "getOfflineReport"
  )}?rpt_type=${type}&start_date=${fDate.split("T")[0]}&end_date=${
    tDate.split("T")[0]
  }${msisdnString}${callerIdString}${iTypeString}${userIdString}${directionString}${displayStatusString}${providerString}${finalStatusString}${enterpriseNumberString}${enterpriseUserNumberString}${customerNumberString}${audioSourceString}${packageNameString}${productTypeString}${rateSheetNameSting}${campaignNameString}`;

  url = url.replace("{ch}", channel).replace("{type}", "download");

  let response = await axios.get(url, config);
  return response;
};

const getWAOfflineReports = async ({ queryKey }) => {
  const loggedRole = queryKey[4];
  const channel = queryKey[2].channel || "wa";
  const fDate = queryKey[2].startDate || "";
  const tDate = queryKey[2].endDate || "";
  const msisdn = queryKey[2].msisdn;

  const whatsAppnumber = queryKey[2].whatsAppnumber
    ? queryKey[2].whatsAppnumber?.toLowerCase() === "all"
      ? ""
      : queryKey[2].whatsAppnumber
    : "";
  const type = queryKey[3] || "";

  const status = queryKey[2].status
    ? queryKey[2].status?.toLowerCase() === "all"
      ? ""
      : queryKey[2].status
    : "";
  const country = queryKey[2].country
    ? queryKey[2].country?.toLowerCase() === "all"
      ? ""
      : queryKey[2].country
    : "";

  const userId = queryKey[2].user
    ? queryKey[2].user?.toLowerCase() === "all"
      ? ""
      : queryKey[2]?.user?.toLowerCase() === "self" && loggedRole === "EA"
      ? queryKey[1]?.sub
      : queryKey[2]?.user?.toLowerCase() === "self"
      ? ""
      : queryKey[2].user
    : "";

  const iType = queryKey[2].interface
    ? queryKey[2].interface?.toLowerCase() === "all"
      ? ""
      : queryKey[2].interface
    : "";
  const direction = queryKey[2].direction
    ? queryKey[2].direction?.toLowerCase() === "all"
      ? ""
      : queryKey[2].direction
    : "";
  const provider = queryKey[2].provider
    ? queryKey[2].provider?.toLowerCase() === "all"
      ? ""
      : queryKey[2].provider
    : "";
  const bind = queryKey[2].bind
    ? queryKey[2].bind?.toLowerCase() === "all"
      ? ""
      : queryKey[2].bind
    : "";

  const msisdnString = msisdn ? `&to=${msisdn}` : "";
  const senderString = whatsAppnumber ? `&from=${whatsAppnumber}` : "";
  const countryString = country ? `&country=${country}` : "";
  const statusString = status ? `&s_st=${status}` : "";
  const iTypeString = iType ? `&i_tp=${waInterfaceMapping[iType]}` : "";
  const directionString = direction ? `&m_ctg=${direction}` : "";

  const userIdString = userId
    ? loggedRole
      ? loggedRole === "PA"
        ? `&o_id=${userId}`
        : `&u_id=${userId}`
      : ""
    : "";
  const providerString = provider ? `&provider=${provider}` : "";
  const bindString = bind ? `&bind=${bind}` : "";

  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]?.token}`,
    },
  };

  let url = `${IP}${getAPIMap(
    "getOfflineReport"
  )}?rpt_type=${type}&start_date=${fDate.split("T")[0]}&end_date=${
    tDate.split("T")[0]
  }${msisdnString}${senderString}${iTypeString}${userIdString}${directionString}${statusString}${providerString}${bindString}${countryString}`;

  url = url.replace("{ch}", channel).replace("{type}", "download");

  let response = await axios.get(url, config);
  return response;
};

const getAllSenderAddressByuser = async (
  search,
  pgIndex,
  token,
  country,
  userId
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let countryString = country
    ? country === "all"
      ? ""
      : `&country=${country}`
    : "";
  let userString = userId ? (userId === "all" ? "" : `&userId=${userId}`) : "";
  let searchString = search ? `&search=${search}` : "";

  let url = `${IP}${getAPIMap(
    "getSenderAddressListByuserId"
  )}?wfstatus=approved,inactive
  ${countryString}${userString}${searchString}`
    .replace(/\n/gm, "")
    .replace(/ /gm, "");

  const response = await axios.get(url, config);

  let senderOptions = [];
  response?.data?.senderAddress?.data?.forEach((ele) => {
    senderOptions.push({ value: ele.senderId, label: ele.senderId });
  });
  response?.data?.numbers?.data?.forEach((ele) => {
    senderOptions.push({
      value: ele.numberId,
      label: ele.numberId,
    });
  });

  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: senderOptions.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const cancelOfflineReports = async (token, channel, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  channel = channel === "wa" ? "sms" : channel;
  let url = `${IP}${getAPIMap("cancelReport")}`;
  url = url
    .replace("{ch}", channel || "sms")
    .replace("{type}", "download")
    .replace("{trackerId}", id);

  let response = await axios.delete(url, config);
  return response;
};

const getPASenderAddressListForReport = async (
  search,
  pgIndex,
  token,
  country
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const countryString = country
    ? country === "all"
      ? ""
      : `&country=${country}`
    : "";

  let url =
    IP +
    getAPIMap("getSenderAddressList") +
    `?pgindex=${pgIndex}&pgsize=${tableDetails.pageSize}${
      search !== "" ? "&search=" + search : ""
    }&wfstatus=approved${countryString}`;
  const response = await axios.get(url, config);
  let senderOptions = [];
  response?.data?.data?.forEach((e) => {
    senderOptions.push({
      value: e.senderId, // e.id - in case uid is required
      label: e.senderId,
    });
  });

  let numbers = await getInvNumberList({
    queryKey: [
      "numbersForReportsPA",
      token,
      undefined,
      undefined,
      { status: "active" },
      search,
    ],
  });

  let numberOptions = [];
  numbers?.data?.data?.forEach((num) => {
    numberOptions.push({ value: num.numberId, label: num.numberId });
  });

  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  if (response.data.data.length < 10) {
    senderOptions = [...senderOptions, ...numberOptions];
  }

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const downloadFileFromUrl = async (token, url, fileName) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob",
    };
    const urlObject = new URL(url);
    const updatedUrl = url.replace(urlObject.origin, IP);
    // Add cache-busting parameter to prevent browser caching
    const cacheBustUrl = updatedUrl + '?_t=' + Date.now();
    const response = await axios.get(cacheBustUrl, config);
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
  } catch (err) {
    console.log("Error while trying to download the file", err);
  }
};

const getSenderAddressesForReport = async (search, pgIndex, token, country) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const countryString = country
    ? country === "all"
      ? ""
      : `&country=${country}`
    : "";

  var url =
    IP +
    getAPIMap("getSenderAddressListEA") +
    `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
      search !== "" ? `&search=${search}` : ""
    }${countryString}`;

  let response = await axios.get(url, config);

  let numbers = await getInvNumberList({
    queryKey: [
      "numbersForReportsEA",
      token,
      undefined,
      undefined,
      undefined,
      search,
      pgIndex,
    ],
  });

  let numberOptions = [];
  numbers?.data?.data?.forEach((num) => {
    numberOptions.push({ value: num.numberId, label: num.numberId });
  });

  let senderOptions = [];
  response?.data?.data?.forEach((e) => {
    senderOptions.push({
      value: e.senderId, // e.id - in case uid is required
      label: e.senderId,
    });
  });

  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  if (response.data.data.length < 10) {
    senderOptions = [...senderOptions, ...numberOptions];
  }

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getPAEmailAddressListForReport = async (search, pgIndex, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let url =
    IP +
    getAPIMap("getEmailAddressList") +
    `?pgindex=${pgIndex}&pgsize=${tableDetails.pageSize}${
      search !== "" ? "&search=" + search : ""
    }&wfstatus=approved`;
  const response = await axios.get(url, config);
  let senderOptions = [];
  response?.data?.data?.forEach((e) => {
    senderOptions.push({
      value: e.senderId, // e.id - in case uid is required
      label: e.senderId,
    });
  });

  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  if (response.data.data.length < 10) {
    senderOptions = [...senderOptions];
  }

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getEmailAddressesForReport = async (search, pgIndex, token, country) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  var url =
    IP +
    getAPIMap("getEmailAddressListEA") +
    `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
      search !== "" ? `&search=${search}` : ""
    }`;

  let response = await axios.get(url, config);

  let senderOptions = [];
  response?.data?.data?.forEach((e) => {
    senderOptions.push({
      value: e.asset_name, // e.id - in case uid is required
      label: e.asset_name,
    });
  });

  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  if (response.data.data.length < 10) {
    senderOptions = [...senderOptions];
  }

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getAllEmailAddressByuser = async (search, pgIndex, token, _, userId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let userString = userId ? (userId === "all" ? "" : `&userId=${userId}`) : "";
  let searchString = search ? `&search=${search}` : "";

  let url = `${IP}${getAPIMap(
    "getEmailAddressListByuserId"
  )}?wfstatus=approved,inactive
  ${userString}${searchString}`
    .replace(/\n/gm, "")
    .replace(/ /gm, "");

  const response = await axios.get(url, config);

  let senderOptions = [];
  response?.data?.senderAddress?.data?.forEach((ele) => {
    senderOptions.push({ value: ele.asset_name, label: ele.asset_name });
  });
  if (pgIndex === 1)
    senderOptions = [...[{ label: "All", value: "all" }], ...senderOptions];

  return {
    options: senderOptions.length > 0 ? senderOptions : [],
    hasMore: senderOptions.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getInvNumberList = async ({ queryKey }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${queryKey[1]}`,
    },
  };

  let url = IP + getAPIMap("getNumbers");
  url = `${url}?pgsize=200&pgindex=${queryKey[6] || 1}`;

  // startDate and EndDate
  if (queryKey[2] || queryKey[3]) {
    url = `${url}&fromDate=${queryKey[2]}&toDate=${queryKey[3]}`;
  }

  if (queryKey[4] && queryKey[4]?.numType) {
    url = `${url}&isPremium=${queryKey[4]?.numType}`;
  }

  if (queryKey[4] && queryKey[4]?.type) {
    url = `${url}&numType=${queryKey[4]?.type}`;
  }

  if (queryKey[4] && queryKey[4]?.cap) {
    url = `${url}&capabilities=${queryKey[4]?.cap}`;
  }

  if (queryKey[4] && queryKey[4]?.status) {
    url = `${url}&status=${queryKey[4]?.status}`;
  }

  if (queryKey[5]) {
    url = `${url}&contains=${encodeURIComponent(queryKey[5])}`;
  }
  let res = await axios.get(url, config);
  return res;
};

const getVoiceCapabilityNumberList = async (
  search,
  prevOptions,
  pgIndex,
  token,
  channel,
  name,
  email,
  accountId
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let url = IP + getAPIMap("getNumbers");

  url = `${url}?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}&isPremium=&numType=&capabilities=&status=active`;
  if (accountId && accountId !== "all") {
    url = url + `&accId=${accountId}`;
  }
  let response = await axios.get(url, config);
  let voiceCapableNumbers = [];
  response.data.data.forEach((ele) => {
    voiceCapableNumbers.push({ value: ele.numberId, label: ele.numberId });
  });
  return {
    options: voiceCapableNumbers.length > 0 ? voiceCapableNumbers : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};
const getVREnabledNumberList = async (search, prevOptions, pgIndex, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let url = IP + getAPIMap("getVR");
  url = `${url}?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}`;

  let response = await axios.get(url, config);
  let VREnabledNumbers = [];
  response.data.data.forEach((ele) => {
    VREnabledNumbers.push({ value: ele.number, label: ele.number });
  });

  return {
    options: VREnabledNumbers.length > 0 ? VREnabledNumbers : [],
    hasMore: response.data.data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};
const getPackageNames = async (pgIndex) => {
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  // var url =
  //   IP +
  //   getAPIMap("enterprisePaginationApi") +
  //   `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
  //     search !== "" ? `&search=${search}` : ""
  //   }`;
  // let response = await axios.get(url, config);

  // let packageOptions = [];
  // response?.data?.data?.forEach((e) => {
  //   packageOptions.push({
  //     value: e.profile.ownerId,
  //     label: e.profile.name,
  //   });
  // });

  // if (pgIndex === 1)
  //   packageOptions = [
  //     ...[
  //       { label: "All", value: "all" },
  //       { label: userName || "Self", value: "self" },
  //     ],
  //     ...packageOptions,
  //   ];

  let packageOptions = [
    { label: "Package 1", value: "Package 1" },
    { label: "Package 2", value: "Package 2" },
  ];

  return {
    options: packageOptions.length > 0 ? packageOptions : [],
    hasMore: false, //response.data.data.length === 10
    additional: {
      page: pgIndex + 1,
    },
  };
};
const getPackageTypes = async (
  //  search,
  //  prevOptions,
  pgIndex
  //  token,
  //  channel,
  //  userName
) => {
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  // var url =
  //   IP +
  //   getAPIMap("enterprisePaginationApi") +
  //   `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
  //     search !== "" ? `&search=${search}` : ""
  //   }`;
  // let response = await axios.get(url, config);

  // let packageOptions = [];
  // response?.data?.data?.forEach((e) => {
  //   packageOptions.push({
  //     value: e.profile.ownerId,
  //     label: e.profile.name,
  //   });
  // });

  // if (pgIndex === 1)
  //   packageOptions = [
  //     ...[
  //       { label: "All", value: "all" },
  //       { label: userName || "Self", value: "self" },
  //     ],
  //     ...packageOptions,
  //   ];

  let packageTypeOptions = [{ label: "otp", value: "OTP" }];

  return {
    options: packageTypeOptions.length > 0 ? packageTypeOptions : [],
    hasMore: false, //response.data.data.length === 10
    additional: {
      page: pgIndex + 1,
    },
  };
};
const getRateSheetNames = async (
  //  search,
  //  prevOptions,
  pgIndex
  //  token,
  //  channel,
  //  userName
) => {
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  // var url =
  //   IP +
  //   getAPIMap("enterprisePaginationApi") +
  //   `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
  //     search !== "" ? `&search=${search}` : ""
  //   }`;
  // let response = await axios.get(url, config);

  // let rateSheetNameOptions = [];
  // response?.data?.data?.forEach((e) => {
  //   rateSheetNameOptions.push({
  //     value: e.profile.ownerId,
  //     label: e.profile.name,
  //   });
  // });

  // if (pgIndex === 1)
  //   rateSheetNameOptions = [
  //     ...[
  //       { label: "All", value: "all" },
  //       { label: userName || "Self", value: "self" },
  //     ],
  //     ...rateSheetNameOptions,
  //   ];

  let rateSheetNameOptions = [
    { label: "Rate Sheet 1", value: "Rate Sheet 1" },
    { label: "Rate Sheet 2", value: "Rate Sheet 2" },
  ];

  return {
    options: rateSheetNameOptions.length > 0 ? rateSheetNameOptions : [],
    hasMore: false, //response.data.data.length === 10
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getCallerIds = async (
  //  search,
  //  prevOptions,
  pgIndex
  //  token,
  //  channel,
  //  userName
) => {
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  // var url =
  //   IP +
  //   getAPIMap("enterprisePaginationApi") +
  //   `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
  //     search !== "" ? `&search=${search}` : ""
  //   }`;
  // let response = await axios.get(url, config);

  // let rateSheetNameOptions = [];
  // response?.data?.data?.forEach((e) => {
  //   rateSheetNameOptions.push({
  //     value: e.profile.ownerId,
  //     label: e.profile.name,
  //   });
  // });

  // if (pgIndex === 1)
  //   rateSheetNameOptions = [
  //     ...[
  //       { label: "All", value: "all" },
  //       { label: userName || "Self", value: "self" },
  //     ],
  //     ...rateSheetNameOptions,
  //   ];

  let callerIdsOptions = [
    { label: "Caller Id 1", value: "Caller Id  1" },
    { label: "Caller Id  2", value: "Caller Id  2" },
  ];

  return {
    options: callerIdsOptions.length > 0 ? callerIdsOptions : [],
    hasMore: false, //response.data.data.length === 10
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getCampaignNames = async (
  //  search,
  //  prevOptions,
  pgIndex
  //  token,
  //  channel,
  //  userName
) => {
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };

  // var url =
  //   IP +
  //   getAPIMap("enterprisePaginationApi") +
  //   `?pgsize=${tableDetails.pageSize}&pgindex=${pgIndex}${
  //     search !== "" ? `&search=${search}` : ""
  //   }`;
  // let response = await axios.get(url, config);

  // let rateSheetNameOptions = [];
  // response?.data?.data?.forEach((e) => {
  //   rateSheetNameOptions.push({
  //     value: e.profile.ownerId,
  //     label: e.profile.name,
  //   });
  // });

  // if (pgIndex === 1)
  //   rateSheetNameOptions = [
  //     ...[
  //       { label: "All", value: "all" },
  //       { label: userName || "Self", value: "self" },
  //     ],
  //     ...rateSheetNameOptions,
  //   ];

  let campaignNamesOptions = [
    { label: "Campaign 1", value: "Campaign  1" },
    { label: "Campaign  2", value: "Campaign  2" },
  ];

  return {
    options: campaignNamesOptions.length > 0 ? campaignNamesOptions : [],
    hasMore: false, //response.data.data.length === 10
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getClients = async (search, pgIndex, token, country, user) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let reportUserId = "";
  if (user && user !== "all" && user !== "self")
    reportUserId = `&reportUserId=${user}`;
  let showRating = `&showQualityRating=false`;
  var url =
    IP + getAPIMap("getClients") + `?pgIndex=1${reportUserId}${showRating}`;
  let response = await axios.get(url, config);

  let wabaNumbers = [];

  response?.data?.data?.forEach((ele) => {
    wabaNumbers.push({
      value: ele.wa_number,
      label: ele.wa_number,
    });
  });

  wabaNumbers = [...[{ label: "All", value: "all" }], ...wabaNumbers];

  return {
    options: wabaNumbers.length > 0 ? wabaNumbers : [],
  };
};

const getTemplateList = async (
  token,
  pgIndex,
  channel,
  search,
  fromDate,
  toDate,
  category,
  status
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const params = [
    fromDate && `fDate=${customDateStartUTCTimeZoneZ(fromDate)}`,
    toDate && `tDate=${customDateEndUTCTimeZoneZ(toDate)}`,
    search && `search=${search}`,
    pgIndex && `pgIndex=${pgIndex - 1}`,
  ]
    .filter(Boolean)
    .join("&");

  const url = `${IP}${getAPIMap("getWaTemplatesList")}${
    params ? `?${params}` : ""
  }`;

  const response = await axios.get(url, config);
  const total = response?.data?.toltalCount || 0;
  let templatesOptions = response?.data?.data?.map((e) => ({
    value: e.template_id || e.id,
    label: e.template_name,
  }));

  return {
    options: templatesOptions,
    hasMore: Math.ceil(total / tableDetails.pageSize) > pgIndex, //data.length === 10,
    additional: {
      page: pgIndex + 1,
    },
  };
};

const getCampList = async (
  token,
  pgIndex,
  channel,
  search,
  fromDate,
  toDate,
  prevOptions
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (channel === "wa") {
    channel = "whatsapp";
  }

  const params = [
    `pgsize=${tableDetails.pageSize}`,
    pgIndex && `pgindex=${pgIndex - 1}`,
    channel && `channels=${channel}`,
    search && `name=${search}`,
    fromDate && `stdt=${fromDate}`,
    toDate && `enddt=${toDate}`,
    `category=VERIFYING,ONGOING,EXPANDED,COMPLETED,PAUSED,CANCELLED,SCHEDULED,SUBMITED,FAILED,EXPIRED`,
  ]
    .filter(Boolean)
    .join("&");

  const url = `${IP}${getAPIMap("listCampaign")}${params ? `?${params}` : ""}`;

  const response = await axios.get(url, config);
  const data = response?.data?.campaigns || [];
  const total = response?.data?.info?.totalsize;
  let campOptions = data?.map((e) => ({
    value: e.campaignId,
    label: e.name,
  }));

  return {
    options: campOptions,
    hasMore: Math.ceil(total / tableDetails.pageSize) > pgIndex,
    additional: {
      page: pgIndex + 1,
    },
  };
};

export {
  getReports,
  getUsersForReports,
  getUsersForReportsEmail,
  getSenderAddressesForReport,
  getEnterprisesForReports,
  downloadFileFromUrl,
  getPASenderAddressListForReport,
  getProvidersForReport,
  getProviderForBind,
  getOfflineReports,
  getEmailOfflineReports,
  cancelOfflineReports,
  getAllSenderAddressByuser,
  getVoiceReports,
  getOfflineVoiceReports,
  getPackageNames,
  getRateSheetNames,
  getCallerIds,
  getCampaignNames,
  getVoiceCapabilityNumberList,
  getVREnabledNumberList,
  getPackageTypes,
  getInvNumberList,
  getEMAILReports,
  getWAOfflineReports,
  getPAEmailAddressListForReport,
  getEmailAddressesForReport,
  getAllEmailAddressByuser,
  getWAReports,
  getClients,
  getCampList,
  getTemplateList,
};
